import { Fragment, useState} from "react";
import { Button } from "@material-tailwind/react";
import {FilterFunction} from './FilterFunction';
import {
  useReactTable,
  flexRender,
  getCoreRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  getFilteredRowModel,
  } from "@tanstack/react-table";


export const BasicTable = ({data,columns}) => {
  const [columnFilters,setColumnFilters] = useState([]);
  const [sorting, setSorting]=useState([]);
  const [filtering, setFiltering]=useState('')
    
  
  const table = useReactTable({
    columns,
    data,
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    state: {
      columnFilters,
      sorting: sorting,
      globalFilter:filtering,
    },
    onColumnFiltersChange:setColumnFilters,
    onSortingChange:setSorting,
    onGlobalFilterChange:setFiltering,
    
  });
  
  
  //const buttonCSS = "px-6 py-1 gap-x-4 rounded-lg text-sm font-nunito font-semibold border-primary-500 bg-white text-secondary-900 hover:bg-primary-500 hover:text-white normal-case"
  const buttonCSS = `m-2 p-2 h-10 w-fit 
                      bg-transparent text-primary-900 hover:text-white hover:bg-primary-900 
                      border-2 rounded-lg 
                      text-base font-bold tracking-widest normal-case items-center`
  return (
    <Fragment>
      <div className="min-w-full overflow-x-auto">
        <table className="min-w-full">
          <thead>
            {table.getHeaderGroups().map((headerGroup) => (
              <tr key={headerGroup.id}>
                {headerGroup.headers.map((header) => {
                  return (
                    <th key={header.id} colSpan={header.colSpan} className="bg-primary-500 text-white text-sm border-[1px] border-gray-400 font-nunito font-semibold">
                      {header.isPlaceholder ? null : (
                        <>
                          <div
                            {...{
                              className: header.column.getCanSort() ? "cursor-pointer select-none" : "",
                              onClick: header.column.getToggleSortingHandler(),
                            }}
                          >
                            {flexRender(header.column.columnDef.header, header.getContext())}
                            {{ asc: "🔼", desc: "🔽" }[header.column.getIsSorted()] ?? null}
                          </div>
                          {header.column.getCanFilter() ? (
                            <div>
                              <FilterFunction column={header.column} table={table} />
                            </div>
                          ) : null}
                        </>
                      )}
                    </th>
                  );
                })}
              </tr>
            ))}
          </thead>

          {table.getRowModel().rows.map((row) => (
            <tbody key={row.id}>
              <tr>
                {row.getVisibleCells().map((cell) => (
                  <td key={cell.id} style={{ width: cell.column.getSize() }} 
                    className="p-1  border-2 border-gray-100 text-secondary-900 text-sm font-nunito">
                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                  </td>
                ))}
              </tr>
            </tbody>
          ))}
        </table>
        <div className="text-[9px]">
          <Button className={`${buttonCSS}`} onClick={() => table.setPageIndex(0)}>
            First Page
          </Button>
          <Button className={`${buttonCSS}`} disabled={!table.getCanPreviousPage()} onClick={() => table.previousPage()}>
            {"<<"}
          </Button>
          <Button className={`${buttonCSS}`} onClick={() => table.nextPage()} disabled={!table.getCanNextPage()}>
            {">>"}
          </Button>
          <Button className={`${buttonCSS}`} onClick={() => table.setPageIndex(table.getPageCount() - 1)}>
            Last Page
          </Button>
        </div>
      </div>
    </Fragment>
  );
};
